export const MICROCOPY = {
  auth: {
    login: {
      subtitle:
        "Accede a tu cuenta para continuar con tu operación inmobiliaria.",
      sideTitle: "Bienvenido de vuelta",
      sideDescription:
        "Retoma tus propiedades, leads y flujos en un solo lugar.",
    },
    register: {
      subtitle:
        "Elige el tipo de cuenta que mejor representa cómo operas hoy.",
      roleHint:
        "Tu rol define funciones, límites y el plan asignado dentro de la plataforma.",
      paidPlanNote:
        "Después del registro podrás activar tu suscripción desde Mi Cuenta. Si eres elegible, la prueba de 14 días aplica una sola vez por cuenta.",
      freePlanNote:
        "Acceso inmediato sin tarjeta, con 1 propiedad incluida para comenzar.",
    },
  },
  account: {
    headline: "Administra tu perfil, seguridad y estado de suscripción.",
    subheadline:
      "Desde aquí puedes actualizar tus datos, proteger tu acceso y gestionar la facturación en Stripe.",
  },
  dashboardModals: {
    commission:
      "Registra solo operaciones con datos verificados para mantener métricas comerciales confiables.",
    lead:
      "Captura el contexto inicial del cliente para priorizar seguimiento y siguiente acción.",
    sale:
      "Confirma la venta cuando el cierre sea definitivo para actualizar comisiones y pipeline.",
    appointment:
      "Alinea fecha, hora y unidad para evitar fricción en la visita comercial.",
  },
  requestForm: {
    headline:
      "Publica una necesidad real cuando aún no encuentras una opción en el marketplace.",
    subheadline:
      "Describe tu búsqueda con contexto comercial para que otros usuarios te respondan con propuestas concretas de su inventario.",
    featureHints: {
      required: "Indispensables para decidir (si no están, no aplica).",
      desired: "Deseables que aportan valor, pero se pueden negociar.",
      flexible: "Opcionales que no bloquean la decisión final.",
    },
    budgetHint:
      "Define un rango que realmente puedas operar para acelerar respuestas útiles.",
    contactPrivacy:
      "Tu nombre, email y teléfono no se publican en la tarjeta. Solo se usan para notificarte cuando recibes respuestas.",
  },
  emptyStates: {
    favorites: {
      title: "Todavía no tienes favoritos guardados",
      description:
        "Guarda propiedades para compararlas después y tomar decisiones con más contexto.",
      primaryCta: "Explorar Propiedades",
      secondaryCta: "Ver Desarrollos",
    },
    inquiries: {
      title: "Aún no has recibido consultas",
      description:
        "Cuando tus publicaciones empiecen a generar interés, aquí verás mensajes, datos de contacto y prioridad comercial.",
      primaryCta: "Ver Mis Propiedades",
      secondaryCta: "Agregar Propiedad",
    },
    propertyRequests: {
      title: "No hay solicitudes activas por ahora",
      description:
        "Este espacio conecta necesidades no cubiertas en el marketplace con usuarios que sí tienen inventario para proponer.",
      premiumGate:
        "Publicar búsquedas requiere Plan Pro, Broker o Developer con suscripción activa.",
      loginGate:
        "Inicia sesión para publicar y gestionar tus búsquedas activas.",
    },
  },
};
